import React, { useState, useEffect, useContext } from "react";
import Whatsapp from "../Assets/WHATSAPP.svg";
import Context from "../../context/Context";

function ChatForHelp() {
  const { whatsUpLink } = useContext(Context);

  return (
    <>
      {whatsUpLink && (
        <div>
          <div className="helpController">
            <img
              onClick={() => (window.location = whatsUpLink)}
              src={Whatsapp}
              style={{ width: "60px" }}
              class="help"
              alt="help"
            />
          </div>
        </div>
      )}
    </>
  );
}

export default ChatForHelp;
